/* This file is autogenerated, see readme.md for instructions */
import ErrorFillSvgIcon from '@bloomreach/banana-theme/icons/error-fill.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ErrorFillIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ErrorFillSvgIcon />
    </Icon>
  );
});

ErrorFillIcon.displayName = 'ErrorFillIcon';

export default ErrorFillIcon;
